import React, { FC } from "react";
import { animated } from "react-spring";
import JGHero from "../images/jghero.png";
import Img from "react-cool-img";
import "./aboutshapes.scss";
import "./heroshapes.scss";

export const AboutShapes = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 787.96 435.61"
      className="shapes"
    >
      <animated.g id="Group_107" data-name="Group 107" className="about-cls-1">
        <circle id="Ellipse_26" data-name="Ellipse 26" className="about-cls-2" cx="217.8" cy="8.5" r="8.5" />
        <circle id="Ellipse_26-2" data-name="Ellipse 26-2" className="about-cls-2" cx="243.97" cy="34.66" r="8.5" />
        <circle id="Ellipse_26-3" data-name="Ellipse 26-3" className="about-cls-2" cx="270.13" cy="60.83" r="8.5" />
        <circle id="Ellipse_26-4" data-name="Ellipse 26-4" className="about-cls-2" cx="322.46" cy="113.15" r="8.5" />
        <circle id="Ellipse_26-5" data-name="Ellipse 26-5" className="about-cls-2" cx="348.62" cy="139.31" r="8.5" />
        <circle id="Ellipse_26-6" data-name="Ellipse 26-6" className="about-cls-2" cx="374.78" cy="165.48" r="8.5" />
        <circle id="Ellipse_26-7" data-name="Ellipse 26-7" className="about-cls-2" cx="400.94" cy="191.64" r="8.5" />
        <circle id="Ellipse_26-8" data-name="Ellipse 26-8" className="about-cls-2" cx="427.11" cy="217.8" r="8.5" />
        <circle id="Ellipse_26-9" data-name="Ellipse 26-9" className="about-cls-2" cx="191.64" cy="34.66" r="8.5" />
        <circle id="Ellipse_26-10" data-name="Ellipse 26-10" className="about-cls-2" cx="243.97" cy="86.99" r="8.5" />
        <circle id="Ellipse_26-11" data-name="Ellipse 26-11" className="about-cls-2" cx="270.13" cy="113.15" r="8.5" />
        <circle id="Ellipse_26-12" data-name="Ellipse 26-12" className="about-cls-2" cx="296.29" cy="139.31" r="8.5" />
        <circle id="Ellipse_26-13" data-name="Ellipse 26-13" className="about-cls-2" cx="348.62" cy="191.64" r="8.5" />
        <circle id="Ellipse_26-14" data-name="Ellipse 26-14" className="about-cls-2" cx="374.78" cy="217.8" r="8.5" />
        <circle id="Ellipse_26-15" data-name="Ellipse 26-15" className="about-cls-2" cx="400.94" cy="243.97" r="8.5" />
        <circle id="Ellipse_26-16" data-name="Ellipse 26-16" className="about-cls-2" cx="165.48" cy="60.83" r="8.5" />
        <circle id="Ellipse_26-17" data-name="Ellipse 26-17" className="about-cls-2" cx="191.64" cy="86.99" r="8.5" />
        <circle id="Ellipse_26-18" data-name="Ellipse 26-18" className="about-cls-2" cx="217.8" cy="113.15" r="8.5" />
        <circle id="Ellipse_26-19" data-name="Ellipse 26-19" className="about-cls-2" cx="243.97" cy="139.31" r="8.5" />
        <circle id="Ellipse_26-20" data-name="Ellipse 26-20" className="about-cls-2" cx="270.13" cy="165.48" r="8.5" />
        <circle id="Ellipse_26-21" data-name="Ellipse 26-21" className="about-cls-2" cx="296.29" cy="191.64" r="8.5" />
        <circle id="Ellipse_26-22" data-name="Ellipse 26-22" className="about-cls-2" cx="322.46" cy="217.8" r="8.5" />
        <circle id="Ellipse_26-23" data-name="Ellipse 26-23" className="about-cls-2" cx="348.62" cy="243.97" r="8.5" />
        <circle id="Ellipse_26-24" data-name="Ellipse 26-24" className="about-cls-2" cx="139.31" cy="86.99" r="8.5" />
        <circle id="Ellipse_26-25" data-name="Ellipse 26-25" className="about-cls-2" cx="165.48" cy="113.15" r="8.5" />
        <circle id="Ellipse_26-26" data-name="Ellipse 26-26" className="about-cls-2" cx="191.64" cy="139.31" r="8.5" />
        <circle id="Ellipse_26-27" data-name="Ellipse 26-27" className="about-cls-2" cx="217.8" cy="165.48" r="8.5" />
        <circle id="Ellipse_26-28" data-name="Ellipse 26-28" className="about-cls-2" cx="243.97" cy="191.64" r="8.5" />
        <circle id="Ellipse_26-29" data-name="Ellipse 26-29" className="about-cls-2" cx="270.13" cy="217.8" r="8.5" />
        <circle id="Ellipse_26-30" data-name="Ellipse 26-30" className="about-cls-2" cx="296.29" cy="243.97" r="8.5" />
        <circle id="Ellipse_26-31" data-name="Ellipse 26-31" className="about-cls-2" cx="322.46" cy="270.13" r="8.5" />
        <circle id="Ellipse_26-32" data-name="Ellipse 26-32" className="about-cls-2" cx="348.62" cy="296.29" r="8.5" />
        <circle id="Ellipse_26-33" data-name="Ellipse 26-33" className="about-cls-2" cx="113.15" cy="113.15" r="8.5" />
        <circle id="Ellipse_26-34" data-name="Ellipse 26-34" className="about-cls-2" cx="139.31" cy="139.31" r="8.5" />
        <circle id="Ellipse_26-35" data-name="Ellipse 26-35" className="about-cls-2" cx="191.64" cy="191.64" r="8.5" />
        <circle id="Ellipse_26-36" data-name="Ellipse 26-36" className="about-cls-2" cx="217.8" cy="217.8" r="8.5" />
        <circle id="Ellipse_26-37" data-name="Ellipse 26-37" className="about-cls-2" cx="243.97" cy="243.97" r="8.5" />
        <circle id="Ellipse_26-38" data-name="Ellipse 26-38" className="about-cls-2" cx="296.29" cy="296.29" r="8.5" />
        <circle id="Ellipse_26-39" data-name="Ellipse 26-39" className="about-cls-2" cx="322.46" cy="322.46" r="8.5" />
        <circle id="Ellipse_26-40" data-name="Ellipse 26-40" className="about-cls-2" cx="86.99" cy="139.31" r="8.5" />
        <circle id="Ellipse_26-41" data-name="Ellipse 26-41" className="about-cls-2" cx="113.15" cy="165.48" r="8.5" />
        <circle id="Ellipse_26-42" data-name="Ellipse 26-42" className="about-cls-2" cx="139.31" cy="191.64" r="8.5" />
        <circle id="Ellipse_26-43" data-name="Ellipse 26-43" className="about-cls-2" cx="165.48" cy="217.8" r="8.5" />
        <circle id="Ellipse_26-44" data-name="Ellipse 26-44" className="about-cls-2" cx="191.64" cy="243.97" r="8.5" />
        <circle id="Ellipse_26-45" data-name="Ellipse 26-45" className="about-cls-2" cx="217.8" cy="270.13" r="8.5" />
        <circle id="Ellipse_26-46" data-name="Ellipse 26-46" className="about-cls-2" cx="243.97" cy="296.29" r="8.5" />
        <circle id="Ellipse_26-47" data-name="Ellipse 26-47" className="about-cls-2" cx="270.13" cy="322.46" r="8.5" />
        <circle id="Ellipse_26-48" data-name="Ellipse 26-48" className="about-cls-2" cx="296.29" cy="348.62" r="8.5" />
        <circle id="Ellipse_26-49" data-name="Ellipse 26-49" className="about-cls-2" cx="86.99" cy="191.64" r="8.5" />
        <circle id="Ellipse_26-50" data-name="Ellipse 26-50" className="about-cls-2" cx="113.15" cy="217.8" r="8.5" />
        <circle id="Ellipse_26-51" data-name="Ellipse 26-51" className="about-cls-2" cx="139.31" cy="243.97" r="8.5" />
        <circle id="Ellipse_26-52" data-name="Ellipse 26-52" className="about-cls-2" cx="165.48" cy="270.13" r="8.5" />
        <circle id="Ellipse_26-53" data-name="Ellipse 26-53" className="about-cls-2" cx="191.64" cy="296.29" r="8.5" />
        <circle id="Ellipse_26-54" data-name="Ellipse 26-54" className="about-cls-2" cx="217.8" cy="322.46" r="8.5" />
        <circle id="Ellipse_26-55" data-name="Ellipse 26-55" className="about-cls-2" cx="243.97" cy="348.62" r="8.5" />
        <circle id="Ellipse_26-56" data-name="Ellipse 26-56" className="about-cls-2" cx="270.13" cy="374.78" r="8.5" />
        <circle id="Ellipse_26-57" data-name="Ellipse 26-57" className="about-cls-2" cx="34.66" cy="191.64" r="8.5" />
        <circle id="Ellipse_26-58" data-name="Ellipse 26-58" className="about-cls-2" cx="60.83" cy="217.8" r="8.5" />
        <circle id="Ellipse_26-59" data-name="Ellipse 26-59" className="about-cls-2" cx="86.99" cy="243.97" r="8.5" />
        <circle id="Ellipse_26-60" data-name="Ellipse 26-60" className="about-cls-2" cx="113.15" cy="270.13" r="8.5" />
        <circle id="Ellipse_26-61" data-name="Ellipse 26-61" className="about-cls-2" cx="139.31" cy="296.29" r="8.5" />
        <circle id="Ellipse_26-62" data-name="Ellipse 26-62" className="about-cls-2" cx="165.48" cy="322.46" r="8.5" />
        <circle id="Ellipse_26-63" data-name="Ellipse 26-63" className="about-cls-2" cx="191.64" cy="348.62" r="8.5" />
        <circle id="Ellipse_26-64" data-name="Ellipse 26-64" className="about-cls-2" cx="243.97" cy="400.94" r="8.5" />
        <circle id="Ellipse_26-65" data-name="Ellipse 26-65" className="about-cls-2" cx="8.5" cy="217.8" r="8.5" />
        <circle id="Ellipse_26-66" data-name="Ellipse 26-66" className="about-cls-2" cx="34.66" cy="243.97" r="8.5" />
        <circle id="Ellipse_26-67" data-name="Ellipse 26-67" className="about-cls-2" cx="60.83" cy="270.13" r="8.5" />
        <circle id="Ellipse_26-68" data-name="Ellipse 26-68" className="about-cls-2" cx="113.15" cy="322.46" r="8.5" />
        <circle id="Ellipse_26-69" data-name="Ellipse 26-69" className="about-cls-2" cx="139.31" cy="348.62" r="8.5" />
        <circle id="Ellipse_26-70" data-name="Ellipse 26-70" className="about-cls-2" cx="165.48" cy="374.78" r="8.5" />
        <circle id="Ellipse_26-71" data-name="Ellipse 26-71" className="about-cls-2" cx="191.64" cy="400.94" r="8.5" />
        <circle id="Ellipse_26-72" data-name="Ellipse 26-72" className="about-cls-2" cx="217.8" cy="427.11" r="8.5" />
      </animated.g>
      <animated.g>
        <path
          className="about-cls-3"
          d="M422.81,409.4,431,284.91,319.7,339.17,422.81,409.4m4.42,9.06-117.47-80,126.76-61.83Z"
          transform="translate(-0.54 -1.36)"
        />
        <path
          className="about-cls-2"
          d="M442.32,386.26l8.15-124.49L339.2,316l103.12,70.23m4.41,9.06-117.47-80L456,253.49Z"
          transform="translate(-0.54 -1.36)"
        />
      </animated.g>
      <animated.g>
        <rect
          className="about-cls-4"
          x="532.17"
          y="106.51"
          width="72.82"
          height="72.82"
          transform="translate(128.41 529.42) rotate(-55.53)"
        />
        <rect
          className="about-cls-5"
          x="510.13"
          y="108.23"
          width="72.82"
          height="72.82"
          transform="translate(117.42 511.99) rotate(-55.53)"
        />
      </animated.g>
      <animated.g>
        <circle className="about-cls-6" cx="624.58" cy="290.2" r="45.1" />
        <circle className="about-cls-7" cx="611.8" cy="277.45" r="45.1" />
      </animated.g>
      <animated.g>
        <path
          className="about-cls-8"
          d="M753,206.26l-15.28,12-13.3-17,15.28-11.95-12.4-15.86,17.45-13.64,12.4,15.86,15.28-12,13.31,17-15.29,12,12.4,15.86-17.45,13.64Z"
          transform="translate(-0.54 -1.36)"
        />
        <path
          className="about-cls-9"
          d="M736.72,205l-15.28,11.95-13.3-17L723.42,188,711,172.11l17.45-13.64,12.4,15.86,15.28-12,13.31,17-15.29,11.95,12.4,15.86-17.45,13.64Z"
          transform="translate(-0.54 -1.36)"
        />
      </animated.g>
      <animated.g>
        <path
          className="about-cls-3"
          d="M369.42,137.58a56.33,56.33,0,0,0,72.33-23.67L339.41,67.64a56.31,56.31,0,0,0,30,69.94m-2.06,4.56a61.32,61.32,0,0,1-30.64-81.21L448.56,111.5a61.34,61.34,0,0,1-81.2,30.64Z"
          transform="translate(-0.54 -1.36)"
        />
        <path
          className="about-cls-2"
          d="M363.74,112.74a56.3,56.3,0,0,0,72.33-23.67L333.74,42.8A55.8,55.8,0,0,0,330.59,60a56.6,56.6,0,0,0,15,39.7,55.88,55.88,0,0,0,18.17,13.07m-2.06,4.56A61.35,61.35,0,0,1,331,36.09L442.89,86.66a61.31,61.31,0,0,1-81.21,30.64Z"
          transform="translate(-0.54 -1.36)"
        />
      </animated.g>
    </svg>
  );
};

export const HeroShapes = React.forwardRef((props: any, ref: any) => {
  const { parallax } = props;

  const trans1 = (x: number, y: number) => `translate3d(${x / 6}px,${y / 6}px,0)`;
  const trans2 = (x: number, y: number) => `translate3d(${x / 8}px,${y / 8}px,0)`;
  const trans3 = (x: number, y: number) => `translate3d(${x / 10}px,${y / 10}px,0)`;
  const trans4 = (x: number, y: number) => `translate3d(${x / 12}px,${y / 12}px,0)`;
  const trans5 = (x: number, y: number) => `translate3d(${x / 14}px,${y / 14}px,0) translateX(-50%)`;

  return (
    <div ref={ref}>
      <animated.div
        className="hero-image-container"
        style={{
          transform: parallax.xy.interpolate(trans5),
        }}
      >
        <Img
          className="hero-image"
          src={JGHero}
          alt="Jona Garcia"
          lazy={true}
          style={{ width: "300px", heigth: "300px" }}
        />
      </animated.div>

      <div className="hero-shapes-wrapper">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 930.28 725.01">
          <animated.g id="Polygon_4" data-name="Polygon 4" style={{ transform: parallax.xy.interpolate(trans3) }}>
            <path
              className="hero-cls-2"
              d="M763.12,291.61l26.45,121.94,92-82.82L763.12,291.61m-6.74-7.5,135,44.57L786.51,423Z"
              transform="translate(-0.61 -69)"
            />
            <path
              className="hero-cls-3"
              d="M739.5,270.11,766,392.05l92-82.82L739.5,270.11m-6.75-7.49,135,44.57L762.89,401.54Z"
              transform="translate(-0.61 -69)"
            />
          </animated.g>
          <animated.g id="Group_186" data-name="Group 186" style={{ transform: parallax.xy.interpolate(trans4) }}>
            <g id="Ellipse_6" data-name="Ellipse 6">
              <circle className="hero-cls-1" cx="498.23" cy="419.19" r="242.03" />
              <circle className="hero-cls-4" cx="498.23" cy="419.19" r="238.03" />
            </g>
            <g id="Ellipse_1" data-name="Ellipse 1">
              <circle className="hero-cls-1" cx="485.98" cy="383.8" r="242.03" />
              <circle className="hero-cls-5" cx="485.98" cy="383.8" r="238.03" />
            </g>
          </animated.g>
          <animated.g id="Group_191" data-name="Group 191" style={{ transform: parallax.xy.interpolate(trans2) }}>
            <rect
              className="hero-cls-6"
              x="729.02"
              y="126.73"
              width="86.01"
              height="86.01"
              transform="translate(105.42 526.52) rotate(-44.99)"
            />
            <rect
              className="hero-cls-7"
              x="700.87"
              y="127.47"
              width="86.01"
              height="86.01"
              transform="translate(96.65 506.83) rotate(-44.99)"
            />
          </animated.g>
          <animated.g id="Group_194" data-name="Group 194" style={{ transform: parallax.xy.interpolate(trans1) }}>
            <g id="Ellipse_5" data-name="Ellipse 5">
              <circle className="hero-cls-1" cx="888.77" cy="57.44" r="41.5" />
              <circle className="hero-cls-8" cx="888.77" cy="57.44" r="39" />
            </g>
            <g id="Ellipse_3" data-name="Ellipse 3">
              <circle className="hero-cls-1" cx="879.58" cy="41.52" r="41.5" />
              <circle className="hero-cls-9" cx="879.58" cy="41.52" r="39" />
            </g>
          </animated.g>
          <animated.g id="Group_190" data-name="Group 190" style={{ transform: parallax.xy.interpolate(trans3) }}>
            <path
              className="hero-cls-11"
              d="M599.87,181.84l-7-18.11L613.08,156,620,174.1l18.79-7.21,7.94,20.67L628,194.77l6.95,18.11-20.16,7.74-7-18.11L589,209.72l-7.93-20.67Z"
              transform="translate(-0.61 -69)"
            />
            <path
              className="hero-cls-12"
              d="M605.84,166.69l-7-18.11L619,140.84,626,159l18.79-7.21,7.93,20.67-18.79,7.22,7,18.11-20.16,7.73-7-18.1L595,194.58,587,173.91Z"
              transform="translate(-0.61 -69)"
            />
          </animated.g>
          <animated.g id="Group_189" data-name="Group 189" style={{ transform: parallax.xy.interpolate(trans2) }}>
            <path
              className="hero-cls-2"
              d="M897.52,242.71a40.69,40.69,0,0,0-14.31-52.77l-36.79,72.2a40.56,40.56,0,0,0,27.41.8,40.49,40.49,0,0,0,23.69-20.23m3.56,1.82A44.67,44.67,0,0,1,841,264.06l40.6-79.67a44.68,44.68,0,0,1,19.53,60.14Z"
              transform="translate(-0.61 -69)"
            />
            <path
              className="hero-cls-3"
              d="M880.61,241.83a40.66,40.66,0,0,0-14.32-52.76l-36.78,72.2a40.19,40.19,0,0,0,11.91,2.7,40.66,40.66,0,0,0,39.19-22.14m3.56,1.82A44.67,44.67,0,0,1,824,263.19l40.59-79.67a44.67,44.67,0,0,1,19.54,60.13Z"
              transform="translate(-0.61 -69)"
            />
          </animated.g>
          <animated.g id="Polygon_4-2" data-name="Polygon 4-2" style={{ transform: parallax.xy.interpolate(trans3) }}>
            <path
              className="hero-cls-2"
              d="M205.73,569.64,175,448.72,86,534.7l119.77,34.94m7,7.25L76.29,537.09l101.46-98Z"
              transform="translate(-0.61 -69)"
            />
            <path
              className="hero-cls-3"
              d="M224.37,590.14,193.66,469.22l-89.06,86,119.77,34.94m7,7.25L94.92,557.59l101.47-98Z"
              transform="translate(-0.61 -69)"
            />
          </animated.g>
          <animated.g id="Group_193" data-name="Group 193" style={{ transform: parallax.xy.interpolate(trans2) }}>
            <rect
              className="hero-cls-13"
              x="138.79"
              y="689.48"
              width="86"
              height="86"
              transform="translate(-323.16 102.04) rotate(-27.99)"
            />
            <rect
              className="hero-cls-14"
              x="146.32"
              y="662.34"
              width="86"
              height="86"
              transform="translate(-309.54 102.39) rotate(-27.99)"
            />
          </animated.g>
          <animated.g id="Group_196" data-name="Group 196" style={{ transform: parallax.xy.interpolate(trans1) }}>
            <circle className="hero-cls-15" cx="41.53" cy="660.06" r="39.02" />
            <circle className="hero-cls-16" cx="48.12" cy="677.24" r="39.02" />
          </animated.g>
          <animated.g id="Group_195" data-name="Group 195" style={{ transform: parallax.xy.interpolate(trans2) }}>
            <path
              className="hero-cls-11"
              d="M64.68,640.15l-8.2-17.58,19.57-9.13L84.25,631l18.24-8.51,9.36,20.07-18.24,8.51,8.19,17.58L82.23,677.8,74,660.21l-18.25,8.51-9.36-20.07Z"
              transform="translate(-0.61 -69)"
            />
            <path
              className="hero-cls-12"
              d="M69.58,624.62,61.38,607,81,597.92l8.2,17.58L107.39,607l9.36,20.07-18.25,8.5,8.2,17.59-19.57,9.12-8.2-17.58L60.69,653.2l-9.36-20.07Z"
              transform="translate(-0.61 -69)"
            />
          </animated.g>
          <animated.g id="Group_188" data-name="Group 188" style={{ transform: parallax.xy.interpolate(trans3) }}>
            <path
              className="hero-cls-2"
              d="M319,712.22a40.71,40.71,0,0,0-33.53,43.19l79.81-14.07A40.61,40.61,0,0,0,349.42,719,40.57,40.57,0,0,0,319,712.22m-.69-3.94a44.68,44.68,0,0,1,51.79,36.28L282,760.07a44.67,44.67,0,0,1,36.27-51.79Z"
              transform="translate(-0.61 -69)"
            />
            <path
              className="hero-cls-3"
              d="M328.48,726.26a40.73,40.73,0,0,0-32.62,31,39.94,39.94,0,0,0-.91,12.18l79.81-14.06a40.27,40.27,0,0,0-5-11.15,40.82,40.82,0,0,0-25.1-17.57,40.33,40.33,0,0,0-16.16-.4m-.69-3.94a44.67,44.67,0,0,1,51.79,36.27l-88.06,15.52a44.67,44.67,0,0,1,36.27-51.79Z"
              transform="translate(-0.61 -69)"
            />
          </animated.g>
        </svg>
      </div>
    </div>
  );
});

export const BackArrow = () => {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1248.65 965.3">
      <polygon points="482.65 965.3 636.8 811.15 417.3 591.65 1248.65 591.65 1248.65 373.65 417.3 373.65 636.8 154.15 482.65 0 0 482.65 482.65 965.3" />
    </svg>
  );
};

export const Close = () => {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 988 988">
      <polygon
        points="948,193.2 988,153.2 948,113.2 834.8,0 794.8,40 494,340.8 193.2,40 153.2,0 113.2,40 40,113.2 0,153.2 340.8,494 
	40,794.8 0,834.8 113.2,948 153.2,988 193.2,948 494,647.2 794.8,948 834.8,988 874.8,948 948,874.8 988,834.8 647.2,494 "
      />
    </svg>
  );
};

export const Instagram = () => {
  return (
    <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.063 169.063">
      <g>
        <path
          d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
     c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
     c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
     c17.455,0,31.656,14.201,31.656,31.655V122.407z"
        />
        <path
          d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
     C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
     c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
        />
        <path
          d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
     c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
     C135.661,29.421,132.821,28.251,129.921,28.251z"
        />
      </g>
    </svg>
  );
};

export const DownArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
      <clipPath id="circleClip">
        <polygon
          className="arrow-1"
          points="27 41.17 27 41.17 27 41.17 40.68 27.5 37.14 23.96 29.5 31.6 29.5 12.83 24.5 12.83 24.5 31.6 16.86 23.96 13.32 27.5 27 41.17"
        />
        <polygon
          className="arrow-2"
          points="27 41.17 27 41.17 27 41.17 40.68 27.5 37.14 23.96 29.5 31.6 29.5 12.83 24.5 12.83 24.5 31.6 16.86 23.96 13.32 27.5 27 41.17"
        />
      </clipPath>

      <circle clipPath="url(#circleClip)" cx="27" cy="27" r="27" />

      <g id="Ellipse_19" data-name="Ellipse 9">
        <circle style={{ fill: "none" }} cx="27" cy="27" r="27" />
        <path
          d="M27.65,54.87a27,27,0,1,1,27-27A27,27,0,0,1,27.65,54.87Zm0-50a23,23,0,1,0,23,23A23,23,0,0,0,27.65,4.87Z"
          transform="translate(-0.65 -0.87)"
        />
      </g>
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="#fff"
        d="M15.003 3h2.997v5h-2.997v-5zm8.997 1v20h-24v-24h20l4 4zm-19 5h14v-7h-14v7zm16 4h-18v9h18v-9z"
      />
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="#fff"
        d="M0 3v18h24v-18h-24zm6.623 7.929l-4.623 5.712v-9.458l4.623 3.746zm-4.141-5.929h19.035l-9.517 7.713-9.518-7.713zm5.694 7.188l3.824 3.099 3.83-3.104 5.612 6.817h-18.779l5.513-6.812zm9.208-1.264l4.616-3.741v9.348l-4.616-5.607z"
      />
    </svg>
  );
};

export const ExpandWork = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.04 17.99">
      <polygon points="18.04 0 18.04 7 16.04 7 16.04 3.4 9.73 9.71 8.33 8.31 11.84 4.8 14.64 2 11.04 2 11.04 0 18.04 0" />
      <polygon points="3.45 15.99 7.04 15.99 7.04 17.99 0.05 17.99 0.05 11 2.05 11 2.05 14.6 8.36 8.29 9.76 9.69 3.45 15.99" />
      <path d="M12,3V5H5v7H3V5A2,2,0,0,1,5,3Z" transform="translate(-3 -3)" />
      <path d="M21,12v7a2,2,0,0,1-2,2H12V19h7V12Z" transform="translate(-3 -3)" />
    </svg>
  );
};

export const ExternalLinkIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <polyline points="11 0 11 2 14.6 2 4.8 11.8 6.2 13.2 16 3.4 16 7 18 7 18 0" />
      <path d="M19,19H5V5h7V3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V12H19Z" transform="translate(-3 -3)" />
    </svg>
  );
};

export const Github = () => {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 23.41">
      <path
        d="M11.51,0a12,12,0,0,0-3.3,23.38c.6.11.79-.26.79-.58V20.58c-3.34.72-4-1.42-4-1.42A3.19,3.19,0,0,0,3.63,17.4c-1.08-.74.09-.72.09-.72a2.52,2.52,0,0,1,1.84,1.23,2.54,2.54,0,0,0,3.49,1,2.53,2.53,0,0,1,.76-1.6C7.15,17,4.34,16,4.34,11.37A4.63,4.63,0,0,1,5.58,8.15,4.28,4.28,0,0,1,5.7,5s1-.32,3.3,1.23a11.49,11.49,0,0,1,3-.41,11.63,11.63,0,0,1,3,.41C17.3,4.66,18.3,5,18.3,5a4.23,4.23,0,0,1,.12,3.17,4.63,4.63,0,0,1,1.24,3.22c0,4.61-2.81,5.63-5.48,5.93A2.86,2.86,0,0,1,15,19.52v3.29c0,.32.19.69.8.58A12,12,0,0,0,11.51,0Z"
        transform="translate(0 0)"
      />
    </svg>
  );
};

export const JGLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      zoomAndPan="magnify"
      viewBox="0 0 375 375"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <path
        fill="#e25a00"
        d="M 103.902344 19.640625 L 103.902344 127.078125 C 103.902344 140.542969 103.453125 152.261719 102.558594 162.242188 C 101.660156 172.222656 99.753906 180.585938 96.839844 187.3125 C 93.921875 194.042969 89.660156 199.03125 84.054688 202.292969 C 78.449219 205.542969 70.933594 207.171875 61.507812 207.171875 C 51.863281 207.171875 43.332031 205.824219 35.929688 203.132812 C 28.527344 200.441406 23.257812 197.976562 20.117188 195.734375 L 9.691406 233.417969 C 24.042969 243.289062 41.320312 248.230469 61.515625 248.230469 C 80.027344 248.230469 94.988281 245.671875 106.398438 240.539062 C 106.296875 242.644531 106.25 244.753906 106.25 246.886719 C 106.25 264.164062 109.21875 280.253906 115.164062 295.179688 C 121.105469 310.101562 129.179688 323.054688 139.394531 334.042969 C 149.597656 345.03125 161.605469 353.675781 175.398438 359.957031 C 189.199219 366.234375 203.945312 369.375 219.65625 369.375 C 229.296875 369.375 238.492188 367.992188 247.230469 365.234375 C 228.46875 371.550781 208.367188 374.972656 187.492188 374.972656 C 84.007812 374.960938 0 290.953125 0 187.480469 C 0 114.03125 42.332031 50.386719 103.902344 19.640625 Z M 103.902344 19.640625 "
        fillOpacity="1"
        fillRule="evenodd"
      />
      <path
        fill="#e25a00"
        d="M 286.273438 278.84375 L 286.273438 295.671875 C 267.648438 317.4375 246.792969 328.3125 223.683594 328.3125 C 213.589844 328.3125 204.21875 326.238281 195.582031 322.089844 C 186.949219 317.941406 179.480469 312.277344 173.203125 305.09375 C 166.921875 297.917969 161.988281 289.441406 158.402344 279.683594 C 154.8125 269.929688 153.019531 259.433594 153.019531 248.222656 C 153.019531 237.457031 154.644531 227.242188 157.894531 217.597656 C 161.148438 207.957031 165.746094 199.421875 171.6875 192.023438 C 177.632812 184.621094 184.808594 178.789062 193.226562 174.519531 C 201.636719 170.257812 210.898438 168.128906 220.992188 168.128906 C 233.773438 168.128906 245.613281 171.269531 256.492188 177.546875 C 267.367188 183.828125 275.84375 192.917969 281.898438 204.804688 L 316.558594 179.230469 C 308.484375 163.308594 296.421875 150.625 280.386719 141.207031 C 264.339844 131.789062 245.109375 127.066406 222.671875 127.066406 C 206.066406 127.066406 190.707031 130.265625 176.566406 136.65625 C 166.679688 141.132812 157.691406 146.703125 149.617188 153.375 C 150.101562 145.019531 150.347656 136.246094 150.347656 127.058594 L 150.347656 5.578125 L 141.890625 5.578125 C 156.484375 1.945312 171.753906 0 187.480469 0 C 290.953125 0 374.960938 84.007812 374.960938 187.480469 C 374.960938 236.832031 355.851562 281.75 324.640625 315.242188 L 324.640625 244.855469 L 238.15625 244.855469 L 238.15625 278.84375 Z M 286.273438 278.84375 "
        fillOpacity="1"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const Hamburger = () => {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1043.68 999">
      <polygon points="1043.7,0 0,0 0,191.5 1043.7,191.5 1043.7,0 	" />
      <polygon points="0,402.8 0,594.2 1043.7,594.2 1043.7,402.8 1043.7,402.8 	" />
      <polygon points="0,807.5 0,999 1043.7,999 1043.7,807.5 1043.7,807.5 	" />
    </svg>
  );
};

export const JGLogoStroke = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      zoomAndPan="magnify"
      viewBox="0 0 375 375"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <path
        fill="#e25a00"
        d="M 103.902344 19.640625 L 103.902344 127.078125 C 103.902344 140.542969 103.453125 152.261719 102.558594 162.242188 C 101.660156 172.222656 99.753906 180.585938 96.839844 187.3125 C 93.921875 194.042969 89.660156 199.03125 84.054688 202.292969 C 78.449219 205.542969 70.933594 207.171875 61.507812 207.171875 C 51.863281 207.171875 43.332031 205.824219 35.929688 203.132812 C 28.527344 200.441406 23.257812 197.976562 20.117188 195.734375 L 9.691406 233.417969 C 24.042969 243.289062 41.320312 248.230469 61.515625 248.230469 C 80.027344 248.230469 94.988281 245.671875 106.398438 240.539062 C 106.296875 242.644531 106.25 244.753906 106.25 246.886719 C 106.25 264.164062 109.21875 280.253906 115.164062 295.179688 C 121.105469 310.101562 129.179688 323.054688 139.394531 334.042969 C 149.597656 345.03125 161.605469 353.675781 175.398438 359.957031 C 189.199219 366.234375 203.945312 369.375 219.65625 369.375 C 229.296875 369.375 238.492188 367.992188 247.230469 365.234375 C 228.46875 371.550781 208.367188 374.972656 187.492188 374.972656 C 84.007812 374.960938 0 290.953125 0 187.480469 C 0 114.03125 42.332031 50.386719 103.902344 19.640625 Z M 103.902344 19.640625 "
        fillOpacity="1"
        fillRule="evenodd"
      />
      <path
        fill="#e25a00"
        d="M 286.273438 278.84375 L 286.273438 295.671875 C 267.648438 317.4375 246.792969 328.3125 223.683594 328.3125 C 213.589844 328.3125 204.21875 326.238281 195.582031 322.089844 C 186.949219 317.941406 179.480469 312.277344 173.203125 305.09375 C 166.921875 297.917969 161.988281 289.441406 158.402344 279.683594 C 154.8125 269.929688 153.019531 259.433594 153.019531 248.222656 C 153.019531 237.457031 154.644531 227.242188 157.894531 217.597656 C 161.148438 207.957031 165.746094 199.421875 171.6875 192.023438 C 177.632812 184.621094 184.808594 178.789062 193.226562 174.519531 C 201.636719 170.257812 210.898438 168.128906 220.992188 168.128906 C 233.773438 168.128906 245.613281 171.269531 256.492188 177.546875 C 267.367188 183.828125 275.84375 192.917969 281.898438 204.804688 L 316.558594 179.230469 C 308.484375 163.308594 296.421875 150.625 280.386719 141.207031 C 264.339844 131.789062 245.109375 127.066406 222.671875 127.066406 C 206.066406 127.066406 190.707031 130.265625 176.566406 136.65625 C 166.679688 141.132812 157.691406 146.703125 149.617188 153.375 C 150.101562 145.019531 150.347656 136.246094 150.347656 127.058594 L 150.347656 5.578125 L 141.890625 5.578125 C 156.484375 1.945312 171.753906 0 187.480469 0 C 290.953125 0 374.960938 84.007812 374.960938 187.480469 C 374.960938 236.832031 355.851562 281.75 324.640625 315.242188 L 324.640625 244.855469 L 238.15625 244.855469 L 238.15625 278.84375 Z M 286.273438 278.84375 "
        fillOpacity="1"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const LeftArrow: FC<{ color?: string }> = (props) => {
  const { color } = props;
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22.07 37.07"
      style={{ fill: color ? color : "" }}
    >
      <polygon points="22.07 3.54 18.54 0 3.54 15 0 18.54 18.54 37.07 22.07 33.54 7.07 18.54 22.07 3.54" />
    </svg>
  );
};

export const LinkedIn = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
    </svg>
  );
};

export const LinkedInBox = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
    </svg>
  );
};

export const LinkIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M6.188 8.719c.439-.439.926-.801 1.444-1.087 2.887-1.591 6.589-.745 8.445 2.069l-2.246 2.245c-.644-1.469-2.243-2.305-3.834-1.949-.599.134-1.168.433-1.633.898l-4.304 4.306c-1.307 1.307-1.307 3.433 0 4.74 1.307 1.307 3.433 1.307 4.74 0l1.327-1.327c1.207.479 2.501.67 3.779.575l-2.929 2.929c-2.511 2.511-6.582 2.511-9.093 0s-2.511-6.582 0-9.093l4.304-4.306zm6.836-6.836l-2.929 2.929c1.277-.096 2.572.096 3.779.574l1.326-1.326c1.307-1.307 3.433-1.307 4.74 0 1.307 1.307 1.307 3.433 0 4.74l-4.305 4.305c-1.311 1.311-3.44 1.3-4.74 0-.303-.303-.564-.68-.727-1.051l-2.246 2.245c.236.358.481.667.796.982.812.812 1.846 1.417 3.036 1.704 1.542.371 3.194.166 4.613-.617.518-.286 1.005-.648 1.444-1.087l4.304-4.305c2.512-2.511 2.512-6.582.001-9.093-2.511-2.51-6.581-2.51-9.092 0z" />
    </svg>
  );
};

export const PictureIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M5 8.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5zm9 .5l-2.519 4-2.481-1.96-4 5.96h14l-5-8zm8-4v14h-20v-14h20zm2-2h-24v18h24v-18z" />
    </svg>
  );
};

export const Preview = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 17v-10l9 5.146-9 4.854z" />
    </svg>
  );
};

export const RightArrow: FC<{ color?: string }> = (props) => {
  const { color } = props;
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22.07 37.07"
      style={{ fill: color ? color : "" }}
    >
      <polygon points="15,18.5 0,33.5 3.5,37.1 22.1,18.5 18.5,15 3.5,0 0,3.5 " />
    </svg>
  );
};

export const ScrollToTop = () => {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 67">
      <rect className="cls-1" width="67" height="67" rx="7.5" />
      <polygon
        className="cls-2"
        points="33.5 14.84 33.5 14.84 33.5 14.84 15.49 32.85 20.14 37.5 30.21 27.44 30.21 52.16 36.79 52.16 36.79 27.44 46.85 37.5 51.51 32.85 33.5 14.84"
      />
    </svg>
  );
};
